import classnames from "classnames";
import * as React from "react";
import Button from "../button/index";
import { Md5 } from "ts-md5/dist/md5";
const notification = [];
let notificationUpdate;
let intervalID = 0;
function exists(md5) {
    return notification.findIndex(e => e.md5 === md5) >= 0;
}
function deleteNotification(uid, result) {
    const i = notification.findIndex(e => e.uid === uid);
    if (i >= 0) {
        const notify = notification.splice(i, 1);
        if (notify.length > 0 && notify[0].onResult !== undefined)
            notify[0].onResult(result);
        notificationUpdate();
    }
}
function watchNotification() {
    intervalID = window.setInterval(() => {
        const withTimer = notification.filter(e => e.timerS !== undefined && e.timerS > 0);
        if (withTimer.length > 0) {
            withTimer
                .filter(e => Date.now() - e.created > (e.timerS !== undefined ? e.timerS : 0))
                .forEach(e => {
                deleteNotification(e.uid, false);
            });
            notificationUpdate();
        }
        else {
            window.clearInterval(intervalID);
        }
    }, 1000);
}
export class Notification {
    constructor(message) {
        this.UID = ++Notification.lastUID;
        let jsx;
        let text;
        if (typeof message === "string") {
            jsx = <p className={`p-text`}>{message}</p>;
            text = message;
        }
        else {
            jsx = message;
            text = message.props.toString();
        }
        const i = notification.findIndex(e => e.text === text);
        if (i < 0) {
            const md5 = Md5.hashStr(text);
            if (!exists(md5)) {
                notification.push({
                    uid: this.UID,
                    modal: false,
                    jsx,
                    text,
                    declineButton: undefined,
                    acceptButton: undefined,
                    timerS: undefined,
                    created: Date.now(),
                    md5,
                    clickable: false,
                    modalable: false,
                    move: undefined,
                });
                notificationUpdate();
            }
        }
        else {
            notification[i].created = Date.now();
        }
    }
    modal() {
        const n = this.find();
        if (n !== null)
            n.modal = true;
        return this;
    }
    clickable() {
        const n = this.find();
        if (n !== null)
            n.clickable = true;
        return this;
    }
    modalable() {
        const n = this.find();
        if (n !== null)
            n.modalable = true;
        return this;
    }
    declineButton(text) {
        const n = this.find();
        if (n !== null)
            n.declineButton = text;
        return this;
    }
    acceptButton(text) {
        const n = this.find();
        if (n !== null)
            n.acceptButton = text;
        return this;
    }
    timer(timerS) {
        const n = this.find();
        if (n !== null)
            n.timerS = timerS;
        watchNotification();
        return this;
    }
    move(x, y) {
        const n = this.find();
        if (n !== null)
            n.move = [x, y];
        return this;
    }
    onResult(onResult) {
        const n = this.find();
        if (n !== null)
            n.onResult = onResult;
        return this;
    }
    didMount(didMount) {
        const n = this.find();
        if (n !== null)
            n.didMount = didMount;
        return this;
    }
    delete(result) {
        deleteNotification(this.UID, result);
    }
    find() {
        const i = notification.findIndex(e => e.uid === this.UID);
        if (i >= 0) {
            return notification[i];
        }
        return null;
    }
}
Notification.lastUID = 0;
class NotificationView extends React.Component {
    constructor(props) {
        super(props);
        notificationUpdate = () => this.forceUpdate();
    }
    componentDidMount() {
        watchNotification();
        this.extraDidMount();
    }
    componentWillUnmount() {
        window.clearInterval(intervalID);
    }
    componentDidUpdate() {
        this.extraDidMount();
    }
    render() {
        const { prefixCls, className, extraCoverName } = this.props;
        const warpCls = classnames(prefixCls, className, {
            [`${prefixCls}-modal`]: notification.some(e => e.modal),
        });
        return (<div className={warpCls} onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            // notification.forEach(e => {
            //   if (!e.modalable) return
            //   deleteNotification(e.uid, false)
            // })
            const lastMess = notification[notification.length - 1];
            if (!lastMess.modalable)
                return;
            deleteNotification(lastMess.uid, false);
        }}>
        <div className={`${prefixCls}-cover ${extraCoverName ? extraCoverName : ""}`}>{this.notifications()}</div>
      </div>);
    }
    notifications() {
        const { prefixCls, extraMessageName } = this.props;
        const result = notification.map((e, i) => {
            return (<div key={i} className={`${prefixCls}-message ${extraMessageName ? extraMessageName : ""}`} style={e.move !== undefined ? { top: e.move[1], left: e.move[0], position: "absolute" } : {}} onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                if (e.clickable || !this.hasButtons(e)) {
                    deleteNotification(e.uid, false);
                }
            }}>
          {e.jsx}
          {this.buttons(e)}
        </div>);
        });
        return result;
    }
    hasButtons(n) {
        return n.acceptButton !== undefined || n.declineButton !== undefined;
    }
    buttons(n) {
        if (!this.hasButtons(n))
            return false;
        const { prefixCls, extraButton, activeName } = this.props;
        return (<div className={`${prefixCls}-buttons`}>
        {n.acceptButton !== undefined && (<Button inline activeClassName={activeName ? activeName : ""} className={`${prefixCls}-button ${prefixCls}-button-accept ${extraButton ? extraButton : ""}`} onClick={() => {
            deleteNotification(n.uid, true);
        }}>
            {n.acceptButton}
          </Button>)}
        {n.declineButton !== undefined && (<Button inline activeClassName={activeName} className={`${prefixCls}-button ${prefixCls}-button-decline ${extraButton ? extraButton : ""}`} onClick={() => {
            deleteNotification(n.uid, false);
        }}>
            {n.declineButton}
          </Button>)}
      </div>);
    }
    extraDidMount() {
        notification
            .filter(e => e.didMount !== undefined)
            .forEach(e => {
            if (e.didMount !== undefined) {
                e.didMount();
                e.didMount = undefined;
            }
        });
    }
}
NotificationView.Notification = Notification;
NotificationView.defaultProps = {
    prefixCls: "pm-notification",
};
export default NotificationView;
